<template>
    <div class="content-grid content-grid--subpage">
        <Breadcrumbs :title="t(`routes.admin.children.activities.participantTransfer.name`)" />
        <BackLinkTitle :title="t(`routes.admin.children.activities.participantTransfer.name`)" />
        <Card>
            <ActivityParticipantTransferForm
                    :activity-occurrence-id="props.activityOccurrenceId"
                    :participant-id="props.participantId" />
        </Card>
    </div>
</template>

<script lang="ts" setup>
import Card from '@/components/layout/Card.vue';
import BackLinkTitle from '@/components/layout/BackLinkTitle.vue';
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue';
import ActivityParticipantTransferForm from "@/components/activities/ActivityParticipantTransferForm.vue";
import {useI18n} from "vue3-i18n";

const {t} = useI18n()

// eslint-disable-next-line no-undef
const props = defineProps<{
    activityOccurrenceId: string
    participantId: string
}>()
</script>